import request from '@/utils/request'
import store from '@/store'

//获取大客户经销商
export function getSale(data) {
  return request(
    {
      url: '/api/website/getSale',
      method: 'post',
      data,
      loading: false
    },
    res => {
      if (res.code === 200 || res.code === 1) {
        return 'cancel'
      } else {
        return false
      }
    }
  )
}

// 业务范围
export function getBusiness() {
  return request(
    {
      url: store.getters.urlStatus
        ? 'official/setting/businessass'
        : '/official/setting/business',
      method: 'get',
      loading: false
    },
    res => {
      if (res.code === 200 || res.code === 1) {
        return 'cancel'
      } else {
        return false
      }
    }
  )
}

// // 业务范围预览
// export function getBusinessass() {
//   return request(
//     {
//       url: 'official/setting/businessass',
//       method: 'get',
//       loading: false
//     },
//     res => {
//       if (res.code === 200 || res.code === 1) {
//         return 'cancel'
//       } else {
//         return false
//       }
//     }
//   )
// }
